// Author Lin
// Date 2021-03-02 15:54:45

class SithMesMstMachineType {
constructor({
        id = null,
        name = '',
        description = '',
        remark = ''}
= {}) {
    this.id = id;
    this.name = name;
    this.description = description;
    this.remark = remark;
}
}

function newEntity() {
return new SithMesMstMachineType();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'name',
        label: 'label.sith.mst.sithMesMstMachineType.grid.name',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'description',
        label: 'label.sith.mst.sithMesMstMachineType.grid.description',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'remark',
        label: 'label.sith.mst.sithMesMstMachineType.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        }
    ])}

const filter = {
    idFilter : "",
    idListFilter : "",
    nameFilter : "",
    descriptionFilter : ""
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'nameFilter',
        label: 'label.sith.mst.sithMesMstMachineType.filter.name',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'descriptionFilter',
        label: 'label.sith.mst.sithMesMstMachineType.filter.description',
        disabled: false,
        form: {
        type: 'input'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'name',
        label: 'label.sith.mst.sithMesMstMachineType.entity.name',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'description',
        label: 'label.sith.mst.sithMesMstMachineType.entity.description',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'remark',
        label: 'label.sith.mst.sithMesMstMachineType.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {SithMesMstMachineType, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
